export default __webpack_public_path__ + "static/media/c001-fsi-1.410fadce.jpg";